import React, { useEffect, useRef, useState } from "react";
import { ButtonArticleClassCodeTree } from "./ButtonArticleClassCodeTree";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { ArticleClassCode } from "../../../core/services/dataBean/contabilidad/ArticleClassCode.Entity";

interface Tree {
    idChild: number;
    edit?: boolean;
    idAccountantIDType: number;
}

const ArticleClassCodeTreeChilds = ({ idChild, idAccountantIDType, edit }: Tree) => {
    const articleClassCode = useRef(new ArticleClassCode("QuickDataERPCore", "com.quickdataerp.bean.supplier.ArticleClassCode")).current;
    const tree = useDataBean(articleClassCode);

    const [lista, setLista] = useState<any[]>([]);
    const [idchild, setIDchild] = useState<number>(0);

    useEffect(() => {
        getListatree(idChild);
        return () => { setIDchild(0) }
    }, [idChild]);




    const getListatree = (idArbol: number) => {
        if (idArbol > 0) {
            let tmp = _single.getCacheItem('treeciuu_' + idArbol);
            if (tmp) {
                setLista(tmp);
            } else {
                tree.instance.loadArticleClassCodeTree(idArbol).then(
                    (resp: any) => {
                        setLista(resp.Childs);
                        _single.setCacheItem('treeciuu_' + idArbol, resp.Childs);
                    }
                ).catch((err: any) => console.error(err));
            }
        }
    };

    const handleClick = (event: React.MouseEvent, item: any) => {
        event.stopPropagation();
        localStorage.setItem('articleclasscodeTree', JSON.stringify(item.EnvolvedObject.DataBeanProperties));
        const clickedID = item.EnvolvedObject.DataBeanProperties.IDLn;
        setIDchild(clickedID === idchild ? 0 : clickedID);
    }

    return (
        <>


            <ul className="list-group">
                {
                    lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <li className="list-group-item itemh" style={{ border: '0' }} key={item.EnvolvedObject.DataBeanProperties.IDLn} >
                                <div className={idchild === item.EnvolvedObject.DataBeanProperties.IDLn ? 'cursor treeselect d-flex ' : 'cursor d-flex '}
                                >
                                    <div>
                                        {edit &&
                                            <ButtonArticleClassCodeTree
                                                id={item.EnvolvedObject.DataBeanProperties.IDLn}
                                                idAccountantIDType={idAccountantIDType}
                                                bean={item.EnvolvedObject.DataBeanProperties}
                                                updateEvent={() => { getListatree(idChild); }}
                                            />
                                        }
                                    </div>
                                    <div>
                                        {/* {hijo.current} - {item.EnvolvedObject.DataBeanProperties.IDLn} */}
                                        <strong><span className="d-inline-block text-truncate" style={{ maxWidth: '40vw', fontSize: '0.7rem' }}
                                            onClick={(event) => {
                                                handleClick(event, item);

                                            }}>
                                            {item.EnvolvedObject.DataBeanProperties.ArticleClassCode} - {item.EnvolvedObject.DataBeanProperties.Name}
                                        </span> </strong>
                                    </div>
                                    <div>
                                        <span className="badge bg-success ms-1">{item.ChildrenCount}</span>
                                    </div>
                                </div>

                                {(idchild === item.EnvolvedObject.DataBeanProperties.IDLn) &&

                                    <ArticleClassCodeTreeChilds idAccountantIDType={idAccountantIDType} edit={edit} idChild={idchild} />

                                }
                            </li>
                        )
                    })
                }
            </ul>

        </>
    )
};

// Exportando el componente con React.memo para evitar re-renderizados innecesarios
export default React.memo(ArticleClassCodeTreeChilds);
